import React, { ChangeEvent } from "react";
import { Form, InputGroup } from "react-bootstrap";
import ControlFeedback from "./ControlFeedback";
import { ControlProps } from "./Types";

const PercentageControl: React.FC<ControlProps> = ({ name, value, disabled, width, validationResults, onChange, onBlur }) => {

    function onControlChange(e: ChangeEvent<HTMLInputElement>) {
        if (e.target.value === '')
            onChange(e.target.value);

        var digitRex = /^-?\d+[\.]?\d{0,2}$/;
        if (digitRex.test(e.target.value) === true) {
            onChange(e.target.value);
        }
        else {
            console.log("Not a percentage: " + e.target.value);
        }
    }

    let v = '';
    if (value != undefined)
        v = value;

    let isValid = validationResults && validationResults.length > 0 ? false : true;

    if (width === undefined)
        width = '100%';

    let className = "";
    if (validationResults && validationResults.length > 0)
        className = "is-invalid";

    return (
        <div style={{ width: width }}>
            <InputGroup className={className}>
            <Form.Control type='text' name={name} value={v} disabled={disabled} onChange={onControlChange} isInvalid={!isValid} onBlur={onBlur} />
                <InputGroup.Text>
                    %
                </InputGroup.Text>
            </InputGroup>

                <ControlFeedback isValid={isValid} validationResults={validationResults}></ControlFeedback>
        </div>
    );
}
export default PercentageControl;